import isNil from 'lodash/isNil'
import React from 'react'

import { DashboardPermissionGuard } from '@components/utils/DashboardPermissions'
import { Icon, PriceString, ProfitString } from '@fourthwall/components'
import { ArrowShortRightIcon } from '@fourthwall/icons'

import type { VariantItem } from '../../types'
import { VariantImageCell } from '../VariantImageCell'
import * as S from './styled'

type ProductVariantsListItemProps = {
  productVariant: VariantItem
  previewImage?: string
  showPreviewImage: boolean
  showPricing: boolean
  showWeight: boolean
  showSKU: boolean
}

export const ProductVariantsListItem = ({
  productVariant,
  previewImage,
  showPreviewImage,
  showPricing,
  showWeight,
  showSKU,
}: ProductVariantsListItemProps) => {
  const compareAtPrice = productVariant.compareAtPrice?.value
  const profit = productVariant.cost?.value
    ? productVariant.price.value - productVariant.cost.value
    : undefined

  return (
    <S.Container>
      {showPreviewImage && (
        <S.VariantsImageCellWrapper>
          <VariantImageCell
            previewImage={previewImage}
            showPreviewImage={showPreviewImage}
            imagesCount={productVariant.images.length}
            isFirstOfGroup={productVariant.isFirstOfGroup}
            isLastOfGroup={productVariant.isLastOfGroup}
          />
        </S.VariantsImageCellWrapper>
      )}
      <S.Details>
        <div>{productVariant.attributesDescription}</div>
        {showPricing && (
          <S.Price>
            {compareAtPrice && (
              <S.CompareAtPrice style={{ textDecoration: 'line-through', display: 'inline-block' }}>
                <PriceString value={compareAtPrice} />{' '}
              </S.CompareAtPrice>
            )}
            <PriceString value={productVariant.price.value} />
            <DashboardPermissionGuard permission="contributions.profit">
              {profit && <ProfitString value={profit} />}
            </DashboardPermissionGuard>
          </S.Price>
        )}
        <S.DetailsRow>
          {isNil(productVariant.quantity) ? 'Unlimited' : productVariant.quantity} in stock{' '}
          <DashboardPermissionGuard permission="contributions.profit">
            | {productVariant.sold} sold{' '}
          </DashboardPermissionGuard>
        </S.DetailsRow>
        {showWeight && (
          <S.DetailsRow>
            {productVariant.weight?.value} {productVariant.weight?.unit}
          </S.DetailsRow>
        )}
        {showSKU && <S.DetailsRow>#{productVariant.sku}</S.DetailsRow>}
      </S.Details>
      <S.Arrow>
        <Icon component={ArrowShortRightIcon} height={12} />
      </S.Arrow>
    </S.Container>
  )
}
